import { Box, Container, Flex, Heading, Link } from '@radix-ui/themes';
import { Link as RouterLink } from 'react-router-dom';
import { ThemeToggle } from './ThemeToggle';
import type { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <Box style={{ minHeight: '100vh' }}>
      <Box
        asChild
        style={{
          borderBottom: '1px solid var(--gray-a5)',
          position: 'sticky',
          top: 0,
          backgroundColor: 'var(--color-background)',
          zIndex: 10,
        }}
      >
        <header>
          <Container size="3">
            <Flex py="3" px="4" justify="between" align="center">
              <Link asChild weight="bold" size="5" style={{ textDecoration: 'none' }}>
                <RouterLink to="/">
                  <Heading size="5">Elpris</Heading>
                </RouterLink>
              </Link>
              <ThemeToggle />
            </Flex>
          </Container>
        </header>
      </Box>
      <Container size="3" py="6">
        {children}
      </Container>
    </Box>
  );
}
